import { gql } from '@grandvisionhq/graphql';
import { shoppinglistFragment } from '../fragments/shopping-list.js';

const failureFragment = gql`
  fragment UpsertFailureFragment on ShoppinglistUpsertFailure {
    ... on ShoppinglistCreateFailure {
      message
    }
    ... on ShoppinglistAuthorizationFailure {
      message
    }
    ... on ShoppinglistUpdateFailure {
      message
    }
    ... on ShoppinglistNotFoundFailure {
      message
    }
    ... on ShoppinglistInputFailure {
      message
    }
    ... on ShoppinglistFailure {
      message
    }
  }
`;
var UPSERT_SHOPPING_LIST = gql`
  mutation UpsertShoppingList($input: UpsertShoppinglistInput!) {
    upsertShoppinglist(input: $input) {
      shoppinglist {
        ...ShoppinglistFragment
      }
      failure {
        ...UpsertFailureFragment
      }
    }
  }
  ${shoppinglistFragment}
  ${failureFragment}
`;

export { UPSERT_SHOPPING_LIST as default, failureFragment };
//# sourceMappingURL=upsert-shopping-list.js.map
